import React from 'react';
import { Container } from 'src/components/layouts/Container/Container';
import AiChatPanel from 'src/components/layouts/AiChat/AiChat';
import styles from './styles/AiChat.module.scss';

function AiChat() {
  return (
    <Container className={styles.root}>
      <AiChatPanel />
    </Container>
  );
}

export default AiChat;
